module.exports = __webpack_public_path__ + "img/4b61595.png";